import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Snapshot } from 'types';

export const deleteMonitor = ({
  snapshotId,
  monitorId,
}: {
  snapshotId: number;
  monitorId: number;
}) => {
  return axios.delete(`/api/snapshots/${snapshotId}/monitors/${monitorId}`);
};

type UseDeleteMonitorOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof deleteMonitor>;
};

export const useDeleteMonitor = ({
  config,
  snapshotId,
}: UseDeleteMonitorOptions) => {
  return useMutation({
    onMutate: async (deletedMonitor) => {
      await queryClient.cancelQueries(['snapshot', snapshotId]);

      const previousSnapshot = queryClient.getQueryData<Snapshot>([
        'snapshot',
        snapshotId,
      ]);

      queryClient.setQueryData(['snapshot', snapshotId], {
        ...previousSnapshot,
        monitors: previousSnapshot?.monitors?.filter(
          (monitor) => monitor.id !== deletedMonitor.monitorId
        ),
      });

      return previousSnapshot;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: deleteMonitor,
  });
};
